import { render, staticRenderFns } from "./ModalPopUpPlanFreeSimulated.vue?vue&type=template&id=0a40512d&scoped=true"
import script from "./ModalPopUpPlanFreeSimulated.vue?vue&type=script&lang=ts"
export * from "./ModalPopUpPlanFreeSimulated.vue?vue&type=script&lang=ts"
import style0 from "./ModalPopUpPlanFree.scss?vue&type=style&index=0&id=0a40512d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40512d",
  null
  
)

export default component.exports